import { combineReducers } from "redux";
import { authReducer } from "./authReducer";

import { categorySourceReducer } from "./categorySourceReducer";
import { commonReducer } from "./commonReducer";
import { dictionaryReducer } from "./dictionaryReducer";
import { localizedResourceReducer } from './localized-resource/localizedResourceReducer';
import { notifyReducer } from './notify/notifyReducer';
import { uploadReducer } from './upload-file/uploadReducer';

import { boDoiCongAnReducer } from "./bodoi-congan/boDoiCongAnReducer";
import { appConfigReducer } from "./common/appConfigReducer";
import { conCbnvReducer } from "./con-cbnv/conCbnvReduder";
import { nguonBietToiReducer } from './crm-category/nguonBietToiReducer';
import { nguonBietToiTypeReducer } from './crm-category/nguonBietToiTypeReducer';
import { crmHocSinhReducer } from './crm-hocsinh/crmHocSinhReducer';
import { hocSinhAceChiTietReducer } from "./crm-hocsinh/hocSinhAceChiTietReducer";
import { hocSinhAceReducer } from "./crm-hocsinh/hocSinhAceReducer";
import { crmPhuHuynhReducer } from "./crm-phuhuynh/crmPhuHuynhReducer";
import { chienDichReducer } from './crm-survey/chienDichReducer';
import { crmSurveyFormQuestionReducer } from './crm-survey/crmSurveyFormQuestionReducer';
import { crmSurveyFormReducer } from './crm-survey/crmSurveyFormReducer';
import { dmEmailConfigReducer } from './email/dmEmailConfigReducer';
import { emailFormReducer } from "./email/emailFormReducer";
import { emailTemplateReducer } from './email/emailTemplateReducer';
import { formEditorReducer } from './form/formEditorReducer';
import { formEditorTypeReducer } from './form/formEditorTypeReducer';
import { formItemReducer } from './form/formItemReducer';
import { formReducer } from './form/formReducer';
import { formRegisterResultReducer } from './form/formRegisterResultReducer';
import { thongKeSiSoReducer } from "./thong-ke/thongKeSiSoReducer";
import { thongTinCbnvReducer } from "./thongtin-cbnv/thongTinCbnvReducer";
import { foCaAnReducer } from "./thuc-don/foCaAnReducer";
import { foCaAnTruongReducer } from "./thuc-don/foCaAnTruongReducer";
import { foMonAnChiTietReducer } from "./thuc-don/foMonAnChiTietReducer";
import { foThucDonReducer } from "./thuc-don/foThucDonReducer";
import { TRANG_THAI_HOC_SINHReducer } from './trang-thai-hoc-sinh/trangThaiHocSInhReducer';
import { TRANG_THAI_PHU_HUYNHReducer } from './trang-thai-phu-huynh/trangThaiPhuHuynhReducer';
import { giaoVienReducer } from "./danh-muc/giaoVienReducer";
import { sucKhoeReducer } from "./danh-muc/sucKhoeReducer";
import { loaiSucKhoeReducer } from "./danh-muc/loaiSucKhoeReducer";
import { danhMucReducerWrapper } from "./danh-muc/danhMucReducerWrapper";
import { thongKeCSKHReducer } from "./thong-ke/thongKeCSKHReducer";
import { thongKeCRMReducer } from "./thong-ke/thongKeCRMReducer";
import { emailReducer } from "./email/emailReducer";
import { soDiemReducerWrapper } from "./so-diem/soDiemReducerWrapper";


const reducers = combineReducers({
    auth: authReducer,
    appConfig: appConfigReducer,

    dictionary: dictionaryReducer,
    categorySource: categorySourceReducer,
    common: commonReducer,

    uploadFile: uploadReducer,

    notify: notifyReducer,

    localizedResource: localizedResourceReducer,

    trangThaiHocSinh: TRANG_THAI_HOC_SINHReducer,
    trangThaiPhuHuynh: TRANG_THAI_PHU_HUYNHReducer,
    formWrapper: combineReducers({
        form: formReducer,
        formItem: formItemReducer,
        formEditorType: formEditorTypeReducer,
        formEditor: formEditorReducer,
        formRegisterResult: formRegisterResultReducer,
    }),
    crmSurvey: combineReducers({
        crmSurveyFormQuestion: crmSurveyFormQuestionReducer,
        crmSurveyForm: crmSurveyFormReducer,
        chienDich: chienDichReducer

    }),
    crmCategoryWrapper: combineReducers({
        nguonBietToi: nguonBietToiReducer,
        nguonBietToiType: nguonBietToiTypeReducer,

    }),
    email: combineReducers({
        dmEmailConfig: dmEmailConfigReducer,
        template: emailTemplateReducer,
        form: emailFormReducer,
        email: emailReducer

    }),
    crmHocSinh: crmHocSinhReducer,
    thucDonWrapper: combineReducers({
        caAn: foCaAnReducer,
        caAnTruong: foCaAnTruongReducer,
        monAnChiTiet: foMonAnChiTietReducer,
        thucDon: foThucDonReducer
    }),
    crmPhuHuynh: crmPhuHuynhReducer,
    sucKhoe: combineReducers({
        sucKhoe: sucKhoeReducer,
        loaiSucKhoe: loaiSucKhoeReducer

    }),
    hocSinhAce: hocSinhAceReducer,
    hocSinhAceChiTiet: hocSinhAceChiTietReducer,
    thongTinCbnv: thongTinCbnvReducer,
    conCbnv: conCbnvReducer,
    boDoiCongAn: boDoiCongAnReducer,
    thongKe: combineReducers({
        thongKeSiSo: thongKeSiSoReducer,
        cskh: thongKeCSKHReducer,
        crm: thongKeCRMReducer
    }),
    danhMucWrapper: danhMucReducerWrapper,
    giaoVien: giaoVienReducer,
    soDiem: soDiemReducerWrapper,

})

export default reducers

export type RootState = ReturnType<typeof reducers>